import { StyledButton } from '../../atoms/Button/StyledButton';
import { StyledButtonsWrapper } from '../../atoms/UserPanelParent/StyledButtonsWrapper';
import { getString } from '../../../strings';

const ActionButtons = ({
    isAtLeastOneUnpaid,
    showCheckboxes,
    toggleShowCheckboxes,
    toggleIsOpenPayPopup,
    checkedTrainers,
}) => {
    const disablePayButton = checkedTrainers.length === 0;
    return (
        <StyledButtonsWrapper $centerSingleBtn={showCheckboxes} bottomsize>
            {showCheckboxes ? (
                <>
                    <StyledButton
                        hasdeclaredbgcolor="#6786BE"
                        hasdeclaredpadding="0 28px"
                        hasdeclaredfontcolor="#fff"
                        hasdeclaredborderradius="25px"
                        hasdeclaredfontweight="700"
                        hasdeclaredtextalign="center"
                        hasdeclaredfontsize="18px"
                        hasdeclaredtexttransform="uppercase"
                        onClick={toggleIsOpenPayPopup}
                        hasdeclaredopacity={disablePayButton ? 0.75 : 1}
                        disabled={disablePayButton}
                        hasdeclaredcursor={disablePayButton ? 'not-allowed' : 'pointer'}
                    >
                        {getString('open_elment_wyplac')}
                    </StyledButton>
                    <StyledButton
                        hasdeclaredbgcolor="#EE745C"
                        hasdeclaredpadding="0 28px"
                        hasdeclaredfontcolor="#fff"
                        hasdeclaredborderradius="25px"
                        hasdeclaredfontweight="700"
                        hasdeclaredtextalign="center"
                        hasdeclaredcursor="pointer"
                        hasdeclaredfontsize="18px"
                        hasdeclaredtexttransform="uppercase"
                        onClick={toggleShowCheckboxes}
                    >
                        {getString('open_element_anuluj')}
                    </StyledButton>
                </>
            ) : isAtLeastOneUnpaid ? (
                <StyledButton
                    hasdeclaredbgcolor="#EE745C"
                    hasdeclaredpadding="0 28px"
                    hasdeclaredfontcolor="#fff"
                    hasdeclaredborderradius="25px"
                    hasdeclaredfontweight="700"
                    hasdeclaredtextalign="center"
                    hasdeclaredcursor="pointer"
                    hasdeclaredfontsize="18px"
                    hasdeclaredtexttransform="uppercase"
                    hasdeclaredmargin="0 auto"
                    onClick={toggleShowCheckboxes}
                    className="hover-red-effect"
                >
                    {getString('open_elment_wybierz_i_wyplac')}
                </StyledButton>
            ) : null}
        </StyledButtonsWrapper>
    );
};

export default ActionButtons;
